import { Card, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MonthChange from './MonthChange';
import { InfoIcon } from '../../../Components/Icons/Icons';
import CircularProgress from './CircularProgress';
import BarChart from '../../../Components/Charts/BarChart';
import { staticCardColor } from '../../../Utils/helper/AppConstants';
import _ from 'lodash';
import { AppColors } from '../../../Utils/helper/AppColors';
import CustomInfoTooltip from '../../../Components/CustomInfoTooltip';

export default function StatisticsCard(props) {
	const {
		title,
		value,
		total,
		monthChange,
		selectedView,
		selectedFilter,
		additionalFilters,
		tooltip,
		hidePercentageSign,
		getCircularProgressColor,
		mul = 1,
		isCallInfo,
	} = props;
	const [data, setData] = useState([]);
	const [labels, setLabels] = useState([]);

	useEffect(() => {
		if (additionalFilters?.length > 0 && _.isArray(value)) {
			setData(
				value?.map((i) => {
					return {
						label: i?.name,
						data: _.isArray(i?.value) ? i?.value?.map((j) => j?.value?.rate || j?.value) : [],
						backgroundColor: additionalFilters?.find((j) => j?.code == i?.name)?.barColor,
					};
				}),
			);
		} else {
			setData([
				{
					data: value?.length > 0 ? value?.map?.((i) => i.value?.rate || i?.value) : [],
					backgroundColor: selectedView?.COLOR,
				},
			]);
		}
	}, [additionalFilters, selectedFilter, value]);

	useEffect(() => {
		setLabels(
			additionalFilters?.length > 0
				? value?.[0]?.value?.map((i) => i.name)
				: selectedFilter?.values?.length > 0 && selectedFilter?.values,
		);
	}, [value, selectedFilter]);

	const chartData = {
		labels,
		datasets: data,
	};

	return (
		<Card
			sx={{
				gap: '14px',
				borderRadius: '10px',
				height: '100%',
				width: '100%',
				justifyContent: 'space-between',
				paddingX: '20px',
				paddingY: '14px',
			}}
		>
			<Stack direction="row" alignItems="center" gap={1}>
				<Typography fontFamily={'Poppins'} fontStyle={600} fontSize={14} color={AppColors.HEADING_TITLE}>
					{title}
				</Typography>
			

				<CustomInfoTooltip title={tooltip} />
			</Stack>
			<Stack>
				{selectedFilter?.length === 0 && (
					<CircularProgress
						hidePercentageSign={hidePercentageSign}
						hideBorders={true}
						color={getCircularProgressColor(_.isObject(value) ? Math.round(value?.rate) * mul : Math.round(value) * mul)} // Changed things....
						value={_.isObject(value) ? Math.round(value?.rate) * mul : Math.round(value) * mul}
						total={total}
						mul={mul}
						size={122}
						isCallInfo={isCallInfo}
					/>
				)}
				{selectedFilter?.values?.length > 0 && <BarChart grid data={chartData} width="100%" />}
			</Stack>
			{/* <MonthChange title="conversation" change={monthChange} effect="positive" /> */}
		</Card>
	);
}
